/* eslint-disable max-classes-per-file */
import { IServiceReport } from '../models/service-report.model';

export class GetServiceReportById {
  static readonly type = '[Service Report] Get Service Report By Id';
  constructor(public id: string) {}
}

export class CreateServiceReport {
  static readonly type = '[Service Report] Create Service Report';
  constructor(public serviceReport: IServiceReport) {}
}

export class UpdateServiceReport {
  static readonly type = '[Service Report] Update Service Report';
  constructor(public serviceReport: IServiceReport) {}
}

export class DeleteServiceReport {
  static readonly type = '[Service Report] Delete Service Report';
  constructor(public id: string) {}
}

export class PrintServiceReport {
  static readonly type = '[Service Report] Print Service Report';
  constructor(public id: string) {}
}
